"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniSearch = void 0;
const image_button_1 = require("../../components/button/image.button");
const icon_1 = require("../../components/icon");
const icons_1 = require("../../components/icon/icons");
const mithril_component_1 = require("../../components/mithril.component");
const spinner_1 = require("../../components/spinner/spinner");
const theme_1 = require("../../components/theme");
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const omni_search_style_1 = require("./omni.search.style");
(0, theme_1.addStyles)(omni_search_style_1.Style);
class OmniSearch extends mithril_component_1.IMithrilComponent {
    get nodes() {
        const cancelButton = image_button_1.ImageButton.view(icons_1.MaterialIcon.CLOSE, {
            className: omni_search_style_1.CSS.clear,
            onclick: () => services_1.Services.Search.reset()
        });
        const icon = services_1.Services.Search.inFlight ?
            spinner_1.Spinner.view(omni_search_style_1.CSS.icon) :
            icon_1.Icon.view(icons_1.MaterialIcon.SEARCH, { className: omni_search_style_1.CSS.icon });
        return (0, mithril_1.m)('div', { className: omni_search_style_1.CSS.container }, [
            icon,
            (0, mithril_1.m)('input', {
                className: omni_search_style_1.CSS.input,
                type: 'text',
                placeholder: (0, index_1.Translate)(index_1.T.SEARCH),
                value: services_1.Services.Search.inputfilterState.filter,
                oninput: e => this.onChange(e)
            }),
            services_1.Services.Search.inputfilterState.hasFilter() ? cancelButton : null
        ]);
    }
    onChange(e) {
        services_1.Services.Search.inputfilterState.setFilter(e.target.value);
    }
}
exports.OmniSearch = OmniSearch;
//# sourceMappingURL=omni.search.js.map